import React, { useState, useRef, useEffect } from 'react';


export const RMultiTab = props => {
    const [selected, setSelected] = useState(0);

    return <div className={props.linear ? "" : "r-multi-tab " + props.className}>
        {
            props.linear ? props.contents.map((c, i) => {
                if(c.hideIf) return;
                return <div className="mb-5">
                    <h3 style={{marginLeft:15, marginBottom:10}}>{c.title}</h3>
                    <hr className="mt-0 mb-4" />
                    <div>
                        {c.content}
                    </div>
                </div>;
            }) : <>
                <div>
                    {
                        props.contents.filter(c=>c.hideIf == undefined || c.hideIf == false).map((c, i) => {
                            return <div onClick={_ => setSelected(i)} key={i} className={`tab${i == selected ? " selected" : ""}`}>
                                <span>{c.title}</span>
                            </div>;
                        })
                    }
                </div>
                <div>
                    {
                        props.contents.filter(c=>c.hideIf == undefined || c.hideIf == false).map((c, i) => {
                            return <div key={i} className={`content${i == selected ? " selected" : ""}`}>
                                {c.content}
                            </div>;
                        })
                    }
                </div>
            </>
        }
        </div>
}